import(/* webpackMode: "eager" */ "/runner/_work/psx-buy-kbb/psx-buy-kbb/psx-kbb-www/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/runner/_work/psx-buy-kbb/psx-buy-kbb/psx-kbb-www/src/app/ClientAppShell.tsx");
;
import(/* webpackMode: "eager" */ "/runner/_work/psx-buy-kbb/psx-buy-kbb/psx-kbb-www/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/runner/_work/psx-buy-kbb/psx-buy-kbb/psx-kbb-www/src/styles/index.scss");
;
import(/* webpackMode: "eager" */ "/runner/_work/psx-buy-kbb/psx-buy-kbb/psx-kbb-www/node_modules/next/font/google/target.css?{\"path\":\"src/styles/fonts.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":[\"500\",\"600\",\"800\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"fallback\":[\"Arial\",\"sans-serif\"]}],\"variableName\":\"montserrat\"}");
